import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '@components/icon-component';

import style from './style.module.scss';

const BookmarkErrorScreen = () => {
  return (
    <div className={style.mainContainer}>
      <div className={style.container}>
        <div className={style.mainIcon}>
          <Icon name={'bookmark-error-screen'} />
        </div>
        <div className={style.heading}>Dang. This asset data wasn’t downloaded.</div>
        <div className={style.para1}>
          You once created a bookmark for this asset but it’s not part of your data set anymore.
        </div>
        <div className={style.para1}>
          This could be due to a permissions change or because it’s not related to a current
          assigned task, so it wasn’t downloaded.
        </div>

        <div className={`op-view-work-by-column ${style.button} `}>
          <Link className={`op-structure button-link`} to={`/dashboard`}>
            <span>Go back Home</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookmarkErrorScreen;
